import React, { useEffect, useState } from 'react'
import qs from 'qs'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { API__PAYMENTS } from 'api'

import { isEducation } from 'common/utils/permissions'

import IconPending from '../../../svg/iconPending.svg'

import { ORDER_STATUSES } from '../constants'

import BusinessPlans from "./Plans/BusinessPlans"
import EducationPlans from "./Plans/EducationPlans"
import { SubscriptionBanner } from './SubscripitonBanner'

export const SubscriptionTab = ({ className = '' }) => {
    const { t } = useTranslation()
    const location = useLocation()
    const [isPending, setIsPending] = useState(false)

    useEffect(() => {
        let id
        const { order_guid } = qs.parse(location.search, { ignoreQueryPrefix: true })

        const checkOrder = async () => {
            const order = await API__PAYMENTS.GET_ORDER({ guid: order_guid })

            if (ORDER_STATUSES.includes(order.orderStatus)) {
                setIsPending(false)
                clearInterval(id)
            } else {
                setIsPending(true)
            }
        }

        if (order_guid) {
            API__PAYMENTS.CREATE_ORDER({ guid: order_guid })
            id = setInterval(checkOrder, 5 * 1000)
            checkOrder()
            setTimeout(() => clearInterval(id), 5 * 1000 * 60)
        }
    }, [location])

    return (
        <>
            <div className={`subscriptions ${className}`}>
                {isPending ? (
                    <div className="subscriptions__pending">
                        <img className="payment" src={IconPending} alt="" />
                        <span className="pending-text">{t('Pending')}...</span>
                        <h2>
                            {t(
                                'Sometimes activating a tariff can take several minutes. Once the payment has passed, you will receive a confirmation email.',
                            )}
                        </h2>
                    </div>
                ) : (
                    <SubscriptionBanner />
                )}

                {isEducation() ? <EducationPlans /> : <BusinessPlans />}
            </div>
        </>
    )
}
